export const SAVE_ATTORNEYINFO_STARTED = "SAVE_ATTORNEYINFO_STARTED";
export const SAVE_ATTORNEYINFO_SUCESS = "SAVE_ATTORNEYINFO_SUCESS";
export const SAVE_ATTORNEYINFO_FAILED = "SAVE_ATTORNEYINFO_FAILED";

export const GET_ATTORNEYINFO_STARTED = "GET_ATTORNEYINFO_STARTED";
export const GET_ATTORNEYINFO_SUCESS = "GET_ATTORNEYINFO_SUCESS";
export const GET_ATTORNEYINFO_FAILED = "GET_ATTORNEYINFO_FAILED";


export const UPDATE_ATTORNEYDETAILS_STARTED = "UPDATE_ATTORNEYDETAILS_STARTED";
export const UPDATE_ATTORNEYDETAILS_SUCCESS = "UPDATE_ATTORNEYDETAILS_SUCCESS";
export const UPDATE_ATTORNEYDETAILS_FAILED = "UPDATE_ATTORNEYDETAILS_FAILED";


export const GET_ATTORNEYDETAILS_STARTED = "GET_ATTORNEYDETAILS_STARTED";
export const GET_ATTORNEYDETAILS_SUCESS = "GET_ATTORNEYDETAILS_SUCESS";
export const GET_ATTORNEYDETAILS_FAILED = "GET_ATTORNEYDETAILS_FAILED";

export const SAVE_G28FORM_STARTED = "SAVE_G28FORM_STARTED";
export const SAVE_G28FORM_SUCESS = "SAVE_G28FORM_SUCESS";
export const SAVE_G28FORM_FAILED = "SAVE_G28FORM_FAILED";

export const GET_G28FORM_STARTED = "GET_G28FORM_STARTED";
export const GET_G28FORM_SUCESS = "GET_G28FORM_SUCESS";
export const GET_G28FORM_FAILED = "GET_G28FORM_FAILED";


export const UPDATE_G28FORM_STARTED = "UPDATE_G28FORM_STARTED";
export const UPDATE_G28FORM_SUCCESS = "UPDATE_G28FORM_SUCCESS";
export const UPDATE_G28FORM_FAILED = "UPDATE_G28FORM_FAILED";

export const GENERATE_G28FORM_STARTED = "GENERATE_G28FORM_STARTED";
export const GENERATE_G28FORM_SUCCESS = "GENERATE_G28FORM_SUCCESS";
export const GENERATE_G28FORM_FAILED = "GENERATE_G28FORM_FAILED";

export interface IAddAttornis {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    MODEMInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
export const saveAttorneyDetails = (AttorneyInput: any) => {
 
    return {
        type: SAVE_ATTORNEYINFO_STARTED,
        payload: 'status',
        input: AttorneyInput
    };
};

export const getallAttorneyDetails = (companyId) => {
    // alert("newid");
     return {
         type: GET_ATTORNEYINFO_STARTED ,
         payload: 'Value',
         input:companyId
     };
 };
 
 export const getAttorneyDetailsByCompanyId = (getInput) => {
    // alert("newid");
     return {
         type: GET_ATTORNEYDETAILS_STARTED ,
         payload: 'Value',
         input:getInput
     };
 };
 export const updateAttorneyDetailsInput = (updateAttorneyInput: any) => {

    return {
        type: UPDATE_ATTORNEYDETAILS_STARTED,
        payload: 'status',
        input: updateAttorneyInput
    };
 
 };
 
 export const createCaseFlowg28 = (AttorneyInput: any) => {
 
    return {
        type: SAVE_G28FORM_STARTED,
        payload: 'status',
        input: AttorneyInput
    };
};
 

export const  updateCaseFlowg28 = (updateAttorneyInput: any) => {

    return {
        type: UPDATE_G28FORM_STARTED,
        payload: 'status',
        input: updateAttorneyInput
    };
 
 };

 export const getCaseFlowG28ByCaseId = (getInput,ggType) => {
    
     return {
         type: GET_G28FORM_STARTED ,
         payload: 'Value',
         input:getInput,
         inputParam:ggType
     };
 };
 
 export const g28PdfGenerationNew = (getInput) => {
   
    return {
        type: GENERATE_G28FORM_STARTED ,
        payload: 'Value',
        input:getInput
    };
};

 

 